module.exports = __webpack_public_path__ + "images/workspaces-preamble/workspaces-preamble-prompt-board-invite-image.e96bd5132d7721dd55b1.png";